import type { Directive } from 'vue'
import { sanitizeHtml } from '@/lib/sanitize'

export const vSanitize: Directive = {
  created(el, { value }) {
    el.innerHTML = sanitizeHtml(value)
  },
  updated(el, { value }) {
    el.innerHTML = sanitizeHtml(value)
  },
}
